import type { Membership } from "./auth";
import { grantsAccess } from "./access-expiry";

// The platform account (org type "platform") is the internal fastn org that
// platform admins operate from. Since the admin console was extracted to the
// standalone app (ops.fastn.dev), the platform account is hidden from the
// switcher by default. It becomes selectable again when includePlatform is set
// — driven by the per-admin `can_switch_platform_org` flag, toggled from the
// admin console's Platform Users page — so an individual platform admin can
// switch into it when it's enabled for them. Everything else the user belongs
// to stays selectable regardless.
// Local dev keeps it selectable unconditionally: org_platform is where
// community/managed connectors are authored, and there is no admin console on a
// local stack.
// An expired membership is filtered in EVERY mode, ahead of all of the above:
// POST /users/me/switch-account refuses it, so offering it renders an account
// that 403s the moment it is clicked — the dead-end UI engineering rule 7 exists
// to prevent. Filtered here rather than in `memberships` itself because that
// array also backs the current-account display and the "does this user have any
// accounts at all?" check, which must still see every row.
export function getSwitchableAccounts(
  memberships: Membership[],
  includePlatform = false,
): Membership[] {
  const live = memberships.filter((m) => grantsAccess(m.expiresAt));
  if (includePlatform || import.meta.env.MODE === "development") return live;
  return live.filter((m) => m.orgType !== "platform");
}

// Name or slug, because the switcher shows the name but a user who administers
// many orgs knows some of them by slug. Blank query returns the list untouched.
export function filterAccounts(accounts: Membership[], query: string): Membership[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return accounts;
  return accounts.filter((m) =>
    `${m.accountName ?? ""} ${m.accountSlug ?? ""}`.toLowerCase().includes(needle),
  );
}
